<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-8 offset-sm-2">

          <px-card title="Register Customer">

            <div slot="with-padding">
              <form @submit.prevent="submitDetails()">
                <div class="col-xs-12">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="control-label">First Name</label>
                      <input class="form-control" type="text" v-model="form.first_name" required="required">
                    </div>
                    <div class="form-group">
                      <label class="control-label">Last Name</label>
                      <input class="form-control" type="text" v-model="form.last_name" required="required">
                    </div>
                    <div class="form-group">
                      <label class="control-label">Phone Number</label>
                      <input
                          class="form-control"
                          :class="{'is-invalid': errors.phone_number}"
                          v-model="form.phone_number"
                      >

                      <div class="invalid-feedback" v-if="errors.phone_number">
                        {{ errors.phone_number[0] }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Email (Optional)</label>
                      <input
                          class="form-control"
                          type="email"
                          :class="{'is-invalid': errors.customer_email}"
                          v-model="form.customer_email"
                      >

                      <div class="invalid-feedback" v-if="errors.customer_email">
                        {{ errors.customer_email[0] }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">ID Number</label>
                      <input
                          class="form-control"
                          :class="{'is-invalid': errors.national_id}"
                          v-model="form.national_id"
                      >

                      <div class="invalid-feedback" v-if="errors.national_id">
                        {{ errors.national_id[0] }}
                      </div>
                    </div>


                    <div class="form-group">
                      <label>Choose Chama Type</label><br>

                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input type="radio" class="form-check-input" name="chama_type" value="flexChama" v-model="chama_type">
                          FlexChama
                        </label>
                      </div>

                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input type="radio" class="form-check-input" name="chama_type" value="flexInvestor" v-model="chama_type">
                          FlexInvestor
                        </label>
                      </div>
                    </div>


                    <template v-if="chama_type==='flexChama'">
                    <div class="form-group">
                      <label for="">Choose Duration </label><br>

                      <div class="form-check">
                        <label class="form-check-label">
                          <input type="radio" class="form-check-input" name="optradio" value="yearly" v-model="plan_type">Yearly
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input type="radio" class="form-check-input"  name="optradio" value="half_yearly" v-model="plan_type">Six Months
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Select Chama</label>
                      <select  class="form-control" v-model="form.product_id" required>
                        <option :value="item.id" v-for="item in chamas" :key="item.id">{{item.name}}</option>
                      </select>
                    </div>
                    </template>

                    <template v-else>
                    <div>
                      <label>Select 52 Weeks Challenge Package</label>

                      <select  class="form-control" v-model="form.inv_product_id" required>
                        <option :value="item.id" v-for="item in investor_packages" :key="item.id">{{item.product_name}}</option>
                      </select>
                    </div>
                      <br>
                      <div class="form-group">
                        <label class="control-label">Enter Deposit Amount</label>
                        <input class="form-control" type="number" step="min:1" v-model="form.deposit_amount" required="required">
                      </div>
                    </template>
                    <br/>
                    <div class="form-group">
                     <button class="btn btn-warning" type="button" @click="goBack()">Cancel</button>
                     <button class="btn btn-primary ml-3" type="submit" :disabled="loading"> {{loading ? 'Please wait..':'Submit'}}</button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </px-card>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import axios from 'axios';
export default {
data(){
  return {
    loading:false,
    form:{
      first_name:'',
      last_name:'',
      national_id:'',
      phone_number:'',
      customer_email:'',
      product_id:'',
      inv_product_id:'',
      deposit_amount:50,
    },
    plan_type:"yearly",
    chama_type:"flexChama",
    chamas:[],
    errors:[],
    investor_packages:[]
  }
},
  mounted() {
  this.getChamas();
  this.getInvestorPackages();
  },
  watch: {
    plan_type() {
      this.getChamas()
    }
  },
  methods:{
     getChamas() {
       axios.post('chama/products',{type:this.plan_type})
           .then(res => {
             this.chamas = res.data;
             console.log(res.data)
           }).catch(error => {
             console.log(error)
       })
     },
    getInvestorPackages() {
      axios.get('flex-investor/products')
          .then(res => {
            this.investor_packages = res.data;
            console.log(res.data)
          }).catch(error => {
        console.log(error)
      })
    },
    goBack() {
      console.log('hide form')
      bus.$emit('hide_form');
    },
    submitDetails() {
      if (!this.checkDetails()){
        return this.danger_alert_state('All Fields are required!');
      }

      if (this.chama_type === 'flexChama') {
        this.form.inv_product_id = "";
        if (!this.form.product_id) {
          return this.danger_alert_state('Please select chama product!');
        }
      }else {
        this.form.product_id="";
        if (!this.form.inv_product_id) {
          return this.danger_alert_state('Please select 52 weeks challenge product!');
        }
        if (!this.form.deposit_amount) {
          return this.danger_alert_state('Please enter deposit amount!');
        }
      }

        this.loading =true;
      this.form.agent_id = localStorage.getItem('login_id');
      axios.post('membership/account/create',this.form)
          .then(res => {
            this.success_alert_state();
            this.loading=false;
            bus.$emit('hide_form')
          }).catch(err => {

            console.log(err.response)
          let error = err.response.data.error_body;
        if (err.response.data.status ===422) {
           this.errors = error.data;
           error="Please check the validation errors in the form inputs.";
        }
        this.loading=false;

        return this.danger_alert_state(error);
      })

      console.log(this.form)
    },
    checkDetails() {
      return !(this.form.first_name === '' || this.form.last_name === '' ||
          this.form.phone_number === ''  || this.form.national_id === '');

    },

    success_alert_state:function(){
      this.$swal({
        title:"Good job!",
        text:"Customer Registered Successfully.",
        type:'success'
      });
    },
    danger_alert_state:function(message){
      this.$swal({
        title:"Error Occurred!",
        text:message,
        type:'error'
      });
    }
  }

}
</script>